export default __webpack_public_path__ + "static/media/gallery_10.621dbf2b.jpg";